module.exports = __webpack_public_path__ + "static/media/alarm.213b54a2.mp3";